import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="bg-ink-900 px-4 py-12 sm:py-16" data-id="element-264" data-mp="2x19vggedceb3">
      <div className="mx-auto max-w-2xl lg:max-w-5xl" data-id="element-265" data-mp="2wzyvkro1nqp9">
        <h2 className="text-center font-display text-[26px] leading-tight text-white sm:text-4xl" data-id="element-266" data-mp="2szycgtq02rbv">
          Cosa include il <span className="text-brand-400" data-id="element-267" data-mp="2o0v7tadxmn4f">Sistema Anti-Rifiniture™</span>?
        </h2>

        <div className="mt-7 space-y-3 lg:grid lg:grid-cols-2 lg:gap-3 lg:space-y-0" data-id="element-268" data-mp="2j9d7mojqgqki">
          {volumes.map(volume => <article key={volume.number} className="flex h-full gap-3.5 rounded-2xl border border-white/10 bg-ink-800 p-4" data-id="element-269" data-mp="2ebtq9frqnxoc">
              <div className="flex shrink-0 flex-col items-center" data-id="element-270" data-mp="259uasrwdh1ni">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-500/15 text-brand-400" data-id="element-271" data-mp="25c6ogsv3kpur">
                  <BookOpenIcon className="h-5 w-5" aria-hidden="true" data-id="element-272" data-mp="335mbr27xa5ie" />
                </span>
                <span className="mt-2 font-display text-lg leading-none text-white/15" data-id="element-273" data-mp="37wcl0qjgysid">
                  {volume.number}
                </span>
              </div>
              <div data-id="element-274" data-mp="2u6is9x4ufo3d">
                <p className="text-[10px] font-black uppercase tracking-[0.18em] text-brand-400" data-id="element-275" data-mp="2u34r2s7x1kxi">
                  Volume {volume.number}
                </p>
                <h3 className="mt-1 text-[16px] font-extrabold leading-snug text-white" data-id="element-276" data-mp="3lxf7v5iag6uc">
                  {volume.title}
                </h3>
                <p className="mt-2 text-[13.5px] leading-relaxed text-white/60" data-id="element-277" data-mp="3qsuilol01mmj">
                  {volume.text}
                </p>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-278" data-mp="3hwd8moodfusd">
          <CTAButton label="Voglio i 6 volumi clinici" sublabel="Oltre 300 protocolli pronti da applicare" data-id="element-279" data-mp="21f8wbt1wq33d" />
        </div>
      </div>
    </section>;
}